import getInstance from './instance';
import { buildOrder } from './utils';

const instance = getInstance();

/**
 * True when a book builder (BBA) `POST /order` body is a refusal. BBA answers
 * a refused order with HTTP 200 and `{ statusCode: 1, status: false, message }`;
 * an accepted order is `{ statusCode: 0, status: true, data }`.
 */
export const isOrderRefusalBody = (body) =>
  Boolean(body) &&
  typeof body === 'object' &&
  (body.status === false || (body.statusCode !== undefined && body.statusCode !== 0));

// Rejects with the axios response, the same value the instance interceptor
// rejects with for `status: false`, so callers handle one shape.
const rejectRefusedOrder = (response) =>
  isOrderRefusalBody(response?.data) ? Promise.reject(response) : response;

export const generateOrder = ({ draftId, selectedAddressId, numberOfPrints, isDigital }) => {
  const url = '/order';

  const body = buildOrder({
    draftId,
    isDigital,
    numberOfPrints,
    selectedAddressId,
  });

  return instance.post(url, body).then(rejectRefusedOrder);
};

export const regenerateOrder = ({
  draftId,
  isDigital,
  numberOfPrints,
  parentOrderId,
  selectedAddressId,
}) => {
  const url = '/order';
  const body = buildOrder({
    draftId,
    isDigital,
    numberOfPrints,
    parentOrderId,
    selectedAddressId,
  });

  return instance.post(url, body).then(rejectRefusedOrder);
};

export const fetchOrderById = ({ orderId }) => {
  const url = '/order';
  const params = {
    order_id: orderId,
  };

  return instance.get(url, params);
};

export const fetchOrderList = () => {
  const url = '/order';
  return instance
    .get(url)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error));
};

export const fetchDraftListWithDigital = () => {
  const url = '/draft/completed-updated-list';
  return instance
    .get(url)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error));
};

export const updateOrderedDraft = ({ orderId }) => {
  const url = `/order/updateOrderedBook/${orderId}`;

  return instance.post(url);
};

export const updateOrderedPdf = ({ orderId }) => {
  const url = `/order/updateOrderedBook/${orderId}`;

  return instance.post(url);
};

export const generateDraftFromOrder = ({ orderId }) => {
  const url = `/order/${orderId}/generate-draft`;

  return instance.post(url);
};
